import styled from 'styled-components';

import { YatSprite } from '@pkg/components/YatSprite';
import { styledReset } from '@pkg/primitives';

import { type ChipSizeValue } from '../../Chip';
import { tokens as chipTokens } from '../../Chip/tokens';

import { tokens } from './tokens';

interface ChipYatWrapperProps {
    $size: ChipSizeValue;
}

export const ChipYatWrapper = styled.span<ChipYatWrapperProps>`
    --yat_chip-yat-min-height: ${({ $size }) => tokens.wrapper.minHeight[$size]}px;
    --yat_chip-yat-font-size: ${({ $size }) => tokens.yat.fontSize[$size]}px;

    ${styledReset.borderBox};
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 0.2em;
    padding: 0.2em 0.4em;
    min-height: var(--yat_chip-yat-min-height);
    font-size: var(--yat_chip-yat-font-size);
    color: initial;
    // TODO: We shouldn't use the 'border-box/padding-box'
    // gradient technique, as it causes too much aliasing.
    background: ${tokens.wrapper.background};
    border: ${chipTokens.chip.borderWidth}px solid transparent;
    border-radius: 999px;
    user-select: none;
    // Required to prevent layout issues related to the emoji sprites.
    display: inline-grid;
    grid-auto-flow: column;
`;

export const Yat = styled(YatSprite)`
    // TODO: It is problematic that we base the computed size
    // of the ChipYat on the font-size of its child.
    font-size: inherit;
`;
